module.exports = __webpack_public_path__ + "static/media/BoxPlotQ1_3.4b4c13e6.svg";